<template>
  <div
    v-if="DISPLAY_EARNRATE_COMPONENT && earnRateList.length > 0"
    class="lh-container-custom-gutters"
  >
    <div
      id="earn-rate-container"
      class="grid-conatiner"
    >
      <div class="grid-x padding-bottom-m padding-top-m">
        <h3>
          {{ TITLE }}
        </h3>
      </div>
      <div class="grid-x grid-margin-x">
        <!---Earn Rate Details-->
        <EarnRateDetails
          v-for="earnRate in earnRateList"
          :key="earnRate.id"
          :earn-rate="earnRate"
        />
        <!---End Earn Rate Details-->
      </div>
    </div>
  </div>
</template>

<script setup>
import { brand, EARN_RATE } from '../../config';
import EarnRateDetails from './EarnRateDetails';
import earnRateLists from './earnRateLists.json';

const { TITLE, DISPLAY_EARNRATE_COMPONENT } = EARN_RATE || {};
const { earnRateList } = earnRateLists[brand];
</script>


<style lang="scss" scoped>
@import '~@core/csg/src/scss/settings/bcom.scss';
h3 {
  letter-spacing: $h3-letter-spacing;
}
.lh-container-custom-gutters:deep() {
  margin-right: rem-calc(20);
  margin-left: rem-calc(20);
}
</style>